import { useMemo } from "react";
import { useGetStageQuery, useGetStagesQuery } from "./stageEndpoints";
import { Stage } from "../../entities/stage";

export function useStage(stageID: number | undefined) {
  const stageQuery = useGetStageQuery(stageID ?? 0, {
    skip: (stageID ?? 0) <= 0,
  });
  const stageEntity = stageQuery.data;

  return useMemo(() => {
    const ret: typeof stageQuery & { stage?: Stage | undefined } = {
      ...stageQuery,
    };
    if (stageEntity) ret.stage = new Stage(stageEntity);
    return ret;
  }, [stageEntity]);
}

export function useStages() {
  const stageQuery = useGetStagesQuery();
  const stageEntitiesMap = stageQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof stageQuery & {
      stages?: Stage[];
      stagesMap?: { [id: number]: Stage };
    } = {
      ...stageQuery,
      stages: [],
      stagesMap: {},
    };
    if (stageEntitiesMap) {
      const stages: Stage[] = [];
      const stagesMap: { [id: number]: Stage } = {};

      for (const key in stageEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(stageEntitiesMap, key)) {
          const c = stageEntitiesMap[key];
          if (c) {
            const stage = new Stage(c);
            stages.push(stage);
            stagesMap[stage.id] = stage;
          }
        }
      }
      ret.stages = stages;
      ret.stagesMap = stagesMap;
    }

    return ret;
  }, [stageEntitiesMap]);
}
